// 订单管理-->货主产品库房关联-->中英文
export const shipperWarehouseProductLocale = {
    'zhCN': {
        public: {
            whetherStart: '确定启用？',
            whetherStop: '确定停用？',
            whetherTransfer: '确定把产品转移到选择仓库？',
            importTemplate: '货主产品库房关联模板下载'
        },
        shipperWarehouseProduct: {
            shipperName: '货主名称',
            warehouseName: '库房名称',
            productReferred: '产品简称',
            materialGroup: '分型',
            shipperWarehouseProductManagement: '货主产品库房关联维护',
            shipperWarehouseProductDetail: '货主产品库房关联明细',
            warehouseTransferManagement: '产品库房转移',
            warehouseTransfer: '产品转移库房',
            // 验证相关
            shipperNameEmpty: '货主名称不能为空',
            warehouseNameEmpty: '库房名称不能为空',
            productReferredEmpty: '产品简称不能为空',
            dataEmpty: ' 请勾选数据',
            notSelectMultipleWarehouse: '不能选择多个仓库的数据进行转换'

        }
    },
    'enUS': {
        public: {
            whetherStart: 'Are you sure to enable?',
            whetherStop: 'Determined to deactivate?',
            whetherTransfer: 'Are you sure to transfer the product to the selection warehouse?',
            importTemplate: 'Shipper product warehouse associated template download'
        },
        shipperWarehouseProduct: {
            shipperName: 'Shipper Name',
            warehouseName: 'Warehouse  Name',
            productReferred: 'Product short name',
            materialGroup: 'Material Group',
            shipperWarehouseProductManagement: 'Shipper product warehouse related maintenance',
            shipperWarehouseProductDetail: 'Shipper product warehouse related details',
            warehouseTransferManagement: 'Product warehouse transfer',
            warehouseTransfer: 'Product transfer warehouse',
            // 验证相关
            shipperNameEmpty: 'The Shipper Name Cannot Be Empty',
            warehouseNameEmpty: 'The warehouse name cannot be empty',
            productReferredEmpty: 'Product abbreviation cannot be empty',
            dataEmpty: ' Please tick the data',
            notSelectMultipleWarehouse: 'Cannot select data from multiple warehouses for conversion'
        }
    }
}
export default shipperWarehouseProductLocale



// WEBPACK FOOTER //
// ./src/locale/modules/shipperWarehouseProductLocale.js